import { BlurView } from 'expo-blur';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { View, Text, Pressable, ActivityIndicator, Image, ScrollView } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

import bronzeMedal from '../../assets/images/bronzeMedal.png';
import buttonX from '../../assets/images/buttons/buttonX.png';
import goldMedal from '../../assets/images/goldMedal.png';
import ranking from '../../assets/images/ranking.png';
import silverMedal from '../../assets/images/silverMedal.png';
import { styles } from './styles';

const RankingCard = ({ setRenderRanking, lastScoreId }) => {
  const { width, height } = useSafeAreaFrame();
  const db = getFirestore();

  const [loading, setLoading] = useState(true);
  const [scores, setScores] = useState([]);

  useEffect(() => {
    (async () => {
      const querySnapshot = await getDocs(collection(db, 'scores'));
      const data = [];

      querySnapshot.forEach((doc) => {
        data.push(doc.data());
      });

      data.forEach((obj) => {
        if (!obj.hasOwnProperty('timeLeft')) {
          obj.timeLeft = 0;
        }
      });

      function compareObjects(a, b) {
        if (a.score !== b.score) {
          return b.score - a.score;
        } else {
          return b.timeLeft - a.timeLeft;
        }
      }

      const sortedArray = data.slice().sort(compareObjects);
      console.log(sortedArray);
      setScores(sortedArray);
      setLoading(false);
    })();
  }, []);

  return (
    <View style={{ position: 'absolute' }}>
      <BlurView
        style={{
          height,
          width,
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Pressable
          style={styles.pressableBackground}
          onPress={() => {
            setRenderRanking(false);
          }}
        />

        <View style={styles.container}>
          {loading ? (
            <ActivityIndicator size="large" color="#1F647A" />
          ) : (
            <>
              <Pressable
                onPress={() => {
                  setRenderRanking(false);
                }}
                style={{
                  position: 'absolute',
                  right: 0,
                  flexDirection: 'row',
                  top: -75,
                  borderRadius: 50,
                  backgroundColor: 'white',
                  justifyContent: 'space-evenly',
                  paddingLeft: 14,
                  paddingRight: 8,
                  paddingVertical: 8,
                }}>
                <Text
                  style={{
                    color: '#BF5540',
                    fontFamily: 'Montserrat_400Regular',
                    fontSize: 18,
                    marginRight: 14,
                  }}>
                  Fechar
                </Text>
                <Image style={{ height: 24, width: 24 }} source={buttonX} />
              </Pressable>
              <View style={{ height: 108, width: '100%', justifyContent: 'center' }}>
                <View style={styles.viewLine} />
                <View style={[styles.viewLine, { marginTop: 5 }]} />
                <Text style={styles.title}>Ranking Metalquest</Text>
                <Image source={ranking} style={styles.imageRanking} />
              </View>

              <View style={styles.viewHeader}>
                <Text style={[styles.textHeader, { width: 40 }]}>Posição</Text>
                <Text style={[styles.textHeader, { flex: 1, marginHorizontal: 40 }]}>Nome</Text>
                <Text style={[styles.textHeader, { width: 60 }]}>Pontuação</Text>
              </View>

              <ScrollView
                showsVerticalScrollIndicator={false}
                style={{ height: 400, width: '100%' }}>
                {scores.map((score, index) => {
                  const timeRemaining = 480 - score.timeLeft;
                  const minutes = Math.floor(timeRemaining / 60);

                  const result = timeRemaining - Math.floor(timeRemaining / 60) * 60;

                  const seconds = result.toString().length === 1 ? `0${result}` : result;

                  console.log(minutes, seconds);

                  return (
                    <View style={[styles.viewHeader, { alignItems: 'center' }]}>
                      {index < 3 ? (
                        <Image
                          style={{ width: 34, height: 58 }}
                          source={index === 0 ? goldMedal : index === 1 ? silverMedal : bronzeMedal}
                        />
                      ) : (
                        <Text
                          style={[
                            styles.textHeader,
                            { width: 40, color: '#B9B9B9', textAlign: 'center' },
                          ]}>
                          {index + 1}
                        </Text>
                      )}
                      <Text
                        style={[
                          styles.textHeader,
                          {
                            marginLeft: 40,
                            color: index < 3 ? '#E6B25D' : '#B9B9B9',
                            fontSize: index < 3 ? 24 : 14,
                          },
                        ]}>
                        {score.name}
                      </Text>
                      <View
                        style={{
                          flex: 1,
                          borderBottomWidth: 1,
                          borderBottomColor: index < 3 ? '#E6B25D' : '#B9B9B9',
                          marginRight: 40,
                          marginLeft: 12,
                          borderStyle: 'dashed',
                          paddingTop: index < 3 ? 20 : 12,
                        }}
                      />
                      <Text
                        style={[
                          styles.textHeader,
                          {
                            width: 60,
                            color: index < 3 ? '#E6B25D' : '#B9B9B9',
                            fontSize: index < 3 ? 24 : 14,
                            textAlign: 'center',
                          },
                        ]}>
                        {score.score}
                      </Text>
                    </View>
                  );
                })}
              </ScrollView>

              <Text
                style={[
                  styles.textHeader,
                  {
                    color: '#B9B9B9',
                    fontSize: 14,
                    alignSelf: 'center',
                    marginTop: 40,
                    marginBottom: 20,
                  },
                ]}>
                . . .
              </Text>

              {lastScoreId !== '' && (
                <View style={[styles.viewHeader, { alignItems: 'center' }]}>
                  <Text
                    style={[
                      styles.textHeader,
                      { width: 40, color: '#1F647A', textAlign: 'center' },
                    ]}>
                    {scores.findIndex((obj) => obj.id === lastScoreId) + 1}
                  </Text>

                  <Text
                    style={[
                      styles.textHeader,
                      {
                        marginLeft: 40,
                        color: '#1F647A',
                        fontSize: 16,
                      },
                    ]}>
                    {scores.filter((score) => score.id === lastScoreId)[0].name}
                  </Text>
                  <View
                    style={{
                      flex: 1,
                      borderBottomWidth: 1,
                      borderBottomColor: '#1F647A',
                      marginRight: 40,
                      marginLeft: 12,
                      borderStyle: 'dashed',
                      paddingTop: 15,
                    }}
                  />
                  <Text
                    style={[
                      styles.textHeader,
                      {
                        width: 60,
                        color: '#1F647A',
                        fontSize: 16,
                        textAlign: 'center',
                      },
                    ]}>
                    {
                      scores
                        .sort((a, b) => parseFloat(b.score) - parseFloat(a.score))
                        .filter((score) => score.id === lastScoreId)[0].score
                    }
                  </Text>
                </View>
              )}
            </>
          )}
        </View>
      </BlurView>
    </View>
  );
};

export default RankingCard;
